define(function() {
	const IpsModel = require('civicsBase/ipsModel');

	//must set this.codeDefinitionType to one of the keys in the codeDefinitionUrls object to get data.
	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/',

		codeDefinitionUrls:{
			building:{
				worktypes:'core/codedescriptions/Hansen.CDR.Building.WorkType',
				occupancytypes:'core/codedescriptions/Hansen.CDR.Building.OccupancyType',
				reviewresults:'core/codedescriptions/Hansen.CDR.Building.Reviewresult',
				inspectionresults:'core/codedescriptions/Hansen.CDR.Building.InspectionResult'
			},
			project:{
				worktypes:'core/codedescriptions/Hansen.CDR.Project.WorkType',
				occupancytypes:'core/codedescriptions/Hansen.CDR.Project.OccupancyType',
				subdivision:'core/codedescriptions/Hansen.Property.SubDivision',
				reviewresults:'core/codedescriptions/Hansen.CDR.Project.Reviewresult',
				inspectionresults:'core/codedescriptions/Hansen.CDR.Project.InspectionResult',
			},
			use:{
				worktypes:'core/codedescriptions/Hansen.CDR.Use.WorkType',
				occupancytypes:'core/codedescriptions/Hansen.CDR.Use.OccupancyType',
				reviewresults:'core/codedescriptions/Hansen.CDR.Use.Reviewresult',
				inspectionresults:'core/codedescriptions/Hansen.CDR.Use.InspectionResult',
			},
			planning:{
				worktypes:'core/codedescriptions/Hansen.CDR.Planning.WorkType',
				occupancytypes:'core/codedescriptions/Hansen.CDR.Planning.OccupancyType',
				reviewresults:'core/codedescriptions/Hansen.CDR.Planning.Reviewresult',
				inspectionresults:'core/codedescriptions/Hansen.CDR.Planning.InspectionResult',
				hearings:'core/codedescriptions/Hansen.CDR.Planning.HearingDetail'

			},
			codeenforcement:{
				casegroupcode:'core/codedescriptions/Hansen.CDR.CodeEnforcement.CaseGroup',
				casesource:'core/codedescriptions/Hansen.CDR.CodeEnforcement.Source',
				reviewresults:'core/codedescriptions/Hansen.CDR.CodeEnforcement.Reviewresult',
				inspectionresults:'core/codedescriptions/Hansen.CDR.CodeEnforcement.InspectionResult',
				hearings:'core/codedescriptions/Hansen.CDR.CodeEnforcement.HearingDetail'
			},
			businesslicense:{
				licensecategory:'core/codedescriptions/Hansen.CDR.BusinessLicense.LicenseCategory',
				inspectionresults:'core/codedescriptions/Hansen.CDR.BusinessLicense.InspectionResult',
				reviewresults:'core/codedescriptions/Hansen.CDR.BusinessLicense.Reviewresult'
			},
			tradelicense:{
				licensecategory:'core/codedescriptions/Hansen.CDR.TradeLicense.LicenseCategory',
				inspectionresults:'core/codedescriptions/Hansen.CDR.TradeLicense.InspectionResult',
				reviewresults:'core/codedescriptions/Hansen.CDR.TradeLicense.Reviewresult'
			},
			servicerequest:{}

		},
		url: function() {
			if(this.codeDefinitionType && this.instrumentType){
				 return this.urlRoot + this.codeDefinitionUrls[this.instrumentType.toLowerCase()][this.codeDefinitionType.toLowerCase()];
			}
			return '';
		},
		//attrs contains key/value of model data
		//key: model attribute name
		//value: model attribute value
		validate: function(attrs, options) {
			//errors object to hold error messages.
			//key: portion of jQuery selector for invalid field
			//value:Error Message
			var errors = {};
			//do Validations
			if (!_.isEmpty(errors)) {
				return errors;
			}
		},
		parse: function(response) {
			//console.log('model response', response);

			if (!_.isEmpty(response.data && response.responseStatus)) {
				this.responseStatus = response.responseStatus;
			}
			//Map out the instrument to a standard object.

			_.each(response.data.codeDescriptionItems, function (codeDescript) {
				if( codeDescript.description == null || codeDescript.description.trim().length <= 0 ){
					  codeDescript.description = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				}
			});

			return response.data;
		}
	});
});
